import React, { useState } from "react";
import NavTop from '../components/layoutParts/NavTop';
import Footer from '../components/layoutParts/Footer';
import BottomFixedNav from '../components/mobileComponents/BottomFixedNav';
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { useGlobal } from "../global/GlobalContext";

const MainLayOut = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false);
  const { accessoriesCat, planters, container, loadingCategories } = useGlobal();


  return (
    <>
      <NavTop />
      <div>{children}</div>

      {/* Mobile Footer */}
      <div className="block md:hidden">
        <div
          className="bg-brand-600 p-4 text-white font-medium border-b flex justify-between text-base"
          onClick={() => setShowMenu(!showMenu)}
        >
          <span>More About MPI</span>
          <span className="text-2xl">
            {showMenu ? <BiChevronUp /> : <BiChevronDown />}
          </span>
        </div>
        {showMenu && 
        <Footer
            accessoriesCat={accessoriesCat}
            planters={planters}
            container={container}
            loading={loadingCategories}
          />
        }
      </div>

      {/* Desktop Footer */}
      <div className="hidden md:block">
        <Footer
            accessoriesCat={accessoriesCat}
            planters={planters}
            container={container}
            loading={loadingCategories}
          />
      </div>

      {/* Reserves space so the fixed bottom nav below doesn't cover the last row of content */}
      <div className="h-16 md:hidden" />
      <BottomFixedNav />
    </>
  );
};

export default MainLayOut;
